:host {
  display: block;
}

.ProseMirror p.is-editor-empty:first-child::before {
  color: var(--sc-input-placeholder-color);
  content: attr(data-placeholder);
  float: left;
  height: 0;
  pointer-events: none;
}

.ProseMirror [class~="lead"] {
  color: var(--sc-input-color);
  font-size: var(--sc-input-spacing-small);
  line-height: 1.6;
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}

.ProseMirror a {
  position: relative;
}

.ProseMirror a::before {
  content: "";
  position: absolute;
  bottom: -0.3em;
  left: 0;
  right: 0;
  height: 3px;
  width: 100%;
  @apply bg-gradient-to-r bg-gradient-teal transition-transform duration-200 transform;
  pointer-events: none;
}

.ProseMirror a:hover::before,
.ProseMirror a:focus::before {
  transform: scaleX(0.95);
}

.ProseMirror strong {
  font-weight: 600;
}

.ProseMirror ol {
  counter-reset: list-counter;
  margin-top: var(--sc-input-spacing-small);
  margin-bottom: var(--sc-input-spacing-small);
}

.ProseMirror ol > li {
  position: relative;
}

.ProseMirror ul > li {
  position: relative;
}

.ProseMirror ul > li::before {
  content: "";
  position: absolute;
  background-color: var(--sc-color-gray-400);
  border-radius: 50%;
  width: 0.375em;
  height: 0.375em;
  top: calc(0.875em - 0.1875em);
  left: -1rem;
}

.ProseMirror hr {
  border-color: var(--sc-color-gray-400);
  border-top-width: 1px;
  margin-top: 3em;
  margin-bottom: 3em;
}

.ProseMirror blockquote {
  font-weight: 500;
  font-style: italic;
  color: #1a202c;
  border-left-width: 0.25rem;
  border-left-color: var(--sc-color-gray-400);
  quotes: "\201C""\201D""\2018""\2019";
  margin-top: 1.6em;
  margin-bottom: 1.6em;
  padding-left: 1em;
}

.ProseMirror blockquote p:first-of-type::before {
  content: open-quote;
}

.ProseMirror blockquote p:last-of-type::after {
  content: close-quote;
}

.ProseMirror h1 {
  font-weight: 800;
  font-size: 2.25em;
  margin-top: 0;
  margin-bottom: 0.8888889em;
  line-height: 1.1111111;
}

.ProseMirror h2 {
  font-weight: 700;
  font-size: 1.5em;
  margin-top: 2em;
  margin-bottom: 1em;
  line-height: 1.3333333;
}

.ProseMirror h3 {
  font-weight: 600;
  font-size: var(--sc-input-spacing-small);
  margin-top: 1.6em;
  margin-bottom: 0.6em;
  line-height: 1.6;
}

.ProseMirror h4 {
  font-weight: 600;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  line-height: 1.5;
}

.ProseMirror figure figcaption {
  color: var(--sc-color-gray-600);
  font-size: 0.875em;
  line-height: 1.4285714;
  margin-top: 0.8571429em;
}

.ProseMirror code {
  color: var(--sc-color-gray-900);
  font-weight: 600;
  font-size: 0.875em;
}

.ProseMirror code::before {
  content: "`";
}

.ProseMirror code::after {
  content: "`";
}

.ProseMirror pre {
  color: var(--sc-color-gray-300);
  background-color: var(--sc-color-gray-800);
  overflow-x: auto;
  font-size: 0.875em;
  line-height: 1.7142857;
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
  border-radius: 0.375rem;
  padding-top: 0.8571429em;
  padding-right: 1.1428571em;
  padding-bottom: 0.8571429em;
  padding-left: 1.1428571em;
}

.ProseMirror pre code {
  background-color: transparent;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-weight: 400;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
}

.ProseMirror pre code::before {
  content: "";
}

.ProseMirror pre code::after {
  content: "";
}

.ProseMirror table {
  width: 100%;
  table-layout: auto;
  text-align: left;
  margin-top: 2em;
  margin-bottom: 2em;
  font-size: 0.875em;
  line-height: 1.7142857;
}

.ProseMirror thead {
  color: #1a202c;
  font-weight: 600;
  border-bottom-width: 1px;
  border-bottom-color: var(--sc-color-gray-400);
}

.ProseMirror thead th {
  vertical-align: bottom;
  padding-right: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-left: 0.5714286em;
}

.ProseMirror tbody tr {
  border-bottom-width: 1px;
  border-bottom-color: var(--sc-color-gray-400);
}

.ProseMirror tbody tr:last-child {
  border-bottom-width: 0;
}

.ProseMirror tbody td {
  vertical-align: top;
  padding-top: 0.5714286em;
  padding-right: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-left: 0.5714286em;
}

.ProseMirror {
  font-size: var(--sc-font-size-medium);
  color: var(--sc-input-color);
  line-height: 1.75;
}

.ProseMirror p {
  margin-top: var(--sc-input-spacing-small);
  margin-bottom: var(--sc-input-spacing-small);
}

.ProseMirror img {
  margin-top: 2em;
  margin-bottom: 2em;
}

.ProseMirror video {
  margin-top: 2em;
  margin-bottom: 2em;
}

.ProseMirror figure {
  margin-top: 2em;
  margin-bottom: 2em;
}

.ProseMirror figure > * {
  margin-top: 0;
  margin-bottom: 0;
}

.ProseMirror h2 code {
  font-size: 0.875em;
}

.ProseMirror h3 code {
  font-size: 0.9em;
}

.ProseMirror ul {
  margin-top: var(--sc-input-spacing-small);
  margin-bottom: var(--sc-input-spacing-small);
  list-style: none; // Disable the default marker behaviour.
}

.ProseMirror li {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.ProseMirror ol > li:before {
  left: 0;
}

.ProseMirror > ul > li p {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}

.ProseMirror > ul > li > *:first-child {
  margin-top: var(--sc-input-spacing-small);
}

.ProseMirror > ul > li > *:last-child {
  margin-bottom: var(--sc-input-spacing-small);
}

.ProseMirror > ol > li > *:first-child {
  margin-top: var(--sc-input-spacing-small);
}

.ProseMirror > ol > li > *:last-child {
  margin-bottom: var(--sc-input-spacing-small);
}

.ProseMirror ul ul,
.ProseMirror ul ol,
.ProseMirror ol ul,
.ProseMirror ol ol {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}

.ProseMirror hr + * {
  margin-top: 0;
}

.ProseMirror h2 + * {
  margin-top: 0;
}

.ProseMirror h3 + * {
  margin-top: 0;
}

.ProseMirror h4 + * {
  margin-top: 0;
}

.ProseMirror thead th:first-child {
  padding-left: 0;
}

.ProseMirror thead th:last-child {
  padding-right: 0;
}

.ProseMirror tbody td:first-child {
  padding-left: 0;
}

.ProseMirror tbody td:last-child {
  padding-right: 0;
}

.ProseMirror > :first-child {
  margin-top: 0;
}

.ProseMirror > :last-child {
  margin-bottom: 0;
}

.editor-base {
  position: relative;
  width: 100%;
  font-family: var(--sc-input-font-family);
  font-weight: var(--sc-input-font-weight);
  line-height: var(--sc-line-height-normal);
  letter-spacing: var(--sc-input-letter-spacing);
  vertical-align: middle;
  transition: var(--sc-transition-fast) color, var(--sc-transition-fast) border, var(--sc-transition-fast) box-shadow,
    var(--sc-transition-fast) background-color;
  cursor: text;
  background-color: var(--sc-input-background-color);
  border: solid var(--sc-input-border-width) var(--sc-input-border-color);
}
[contenteditable] {
  position: relative;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  border-top: solid var(--sc-input-border-width) var(--sc-input-border-color);
  padding: var(--sc-input-spacing-medium);
  overflow-y: auto;
  min-height: var(--sc-rich-text-min-height, auto);
  max-height: var(--sc-rich-text-max-height, none);
}

.menu {
  display: flex;
  line-height: 0;
  gap: var(--sc-spacing-xx-small);
  padding: var(--sc-spacing-x-small);
}
.editor-base {
  display: grid;
  gap: 0;
}
.right {
  margin-left: auto;
}
.textarea__char-limit-warning{
  margin-top: var(--sc-input-spacing-small);
  color: var(--sc-input-help-text-color);
  font-size: var(--sc-input-help-text-font-size-medium);
}

